/**
 * Total Golden Chips Balance Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var BaseReplacerView = require('common/base.replacer.view');
    var TotalBalanceModel = require('replacers/total-goldenchips-balance/total-goldenchips-balance.model');

    module.exports = BaseReplacerView.extend({
        tagName: 'span',

        accessRules: {
            allow: ['user']
        },

        initialize: function() {
            BaseReplacerView.prototype.initialize.apply(this, arguments);
            this.model = new TotalBalanceModel();
        },

        render: function() {
            var render = function(data, model) {
                this.$el.html(
                    this.tmpl(
                        'total-goldenchips-balance',
                        data.success ? model.toJSON() : data
                    )
                );
            };

            this.model.fetch({
                success: render.bind(this, { success: true }),
                error: render.bind(this, { error: true })
            });

            return this;
        }
    }, {
        nameOfReplacers: ['TOTAL_GOLDEN_CHIPS_BALANCE']
    });
});
